export var SORT_BY_MAP = {
  updated_at: "recent",
  created_at: "created",
  reminder: "reminder"
};
export var SORT_ORDER_MAP = {
  asc: "asc",
  desc: "desc"
};